<template>
	<!-- 用户管理 -->
	<div class="systemUser">
		<div class="systemUserPC pulbic_system_oparetionBlock">
			<div class="systemUserPC-btn public_operatBtn" style="margin-left: 0px;">
				<el-button class="public_saleWater_xinzeng" type="primary" icon="iconfont icon-tianjia"   id="新增" @click="addclick">新增</el-button>
			</div>
			<div class="systemUserPC-table">
				<div class="systemUserPC-table-li public-table-bg">
					<div class="systemUserPC-table-li-phone">联系电话</div>
					<div class="systemUserPC-table-li-name">姓名</div>
					<div class="systemUserPC-table-li-role">角色</div>
					<div class="systemUserPC-table-li-type" v-if="userType!='SYSTEM'">用户类型</div>
					<div class="systemUserPC-table-li-state">状态</div>
					<div class="systemUserPC-table-li-oper">操作</div>
				</div>
				<div class="systemUserPC-table-li public-hover public-table-bg" v-for="(item,index) in userList" :key="index">
					<div class="systemUserPC-table-li-phone">{{item.PERTB005CA03}}</div>
					<div class="systemUserPC-table-li-name">{{item.PERTB005CA02}}</div>
					<div class="systemUserPC-table-li-role">{{item.PERTB003CA00}}</div>
					<div class="systemUserPC-table-li-type" v-if="userType!='SYSTEM'">{{item.PERTB003CB01==1?'管理员':'普通用户'}}</div>
					<div class="systemUserPC-table-li-state">{{item.PERTB005CD00}}</div>
					<div class="systemUserPC-table-li-oper">
						<div v-if="item.PERTB005CA03!=userobj.pertb005.pertb005ca03">
							<el-button type="primary" class="public_icon_qiyong"   size="small"   id="启用" v-if="item.PERTB005CD00!='启用'" @click="revClick(item)">启用</el-button>
							<el-button type="danger" class="public_icon_jinyong"  size="small"   id="禁用" v-if="item.PERTB005CD00=='启用'" @click="disableClick(item)">禁用</el-button>
							<el-button type="primary" class="public_icon_xiugai"  size="small"   id="修改" @click="updateClick(item)" >修改</el-button>
							<el-button type="danger" class="public_icon_jinyong"  size="small"   id="删除" @click="deleteClick(item)">删除</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="systemUserPC-no-text" v-if="userList.length==0">暂无数据</div>
			<div class="systemUserPC-pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				 :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageNum" 
				 layout="total,sizes, prev, pager, next" :total="count">
				</el-pagination>
			</div>
			<div class="public-dialog">
				<el-dialog :modal="false" title="新增用户" :visible.sync="systemUserAddUser" width="30%" :closeOnClickModal="false">
					<div class="systemUserPC-add-user">
						<div class="systemUserPC-add-user-table">
							<div class="systemUserPC-add-user-li">
								<div>角色</div>
								<div>
									<el-select v-model="adduserObj.PERTB003ID" placeholder="无角色">
									    <el-option
									      v-for="item in roeList"
									      :key="item.value"
									      :label="item.label"
									      :value="item.value">
									    </el-option>
									  </el-select>
								</div>
								<div>*必选*</div>
							</div>
							<div class="systemUserPC-add-user-li">
								<div>手机号</div>
								<div>
									<input type="text" value="" maxlength="11" v-model="adduserObj.PERTB005CA03" @blur="phoneBlur"/>
								</div>
								<div>*必填*</div>
							</div>
							<div class="systemUserPC-add-user-li">
								<div>姓名</div>
								<div>
									<input type="text" value="" maxlength="16" v-model="adduserObj.PERTB005CA02"/>
								</div>
								<div>*必填*</div>
							</div>
						</div>
						<div class="systemUserPC-add-user-btn">
							<el-button type="primary" @click="saveUserPost">保存</el-button>
							<el-button type="warning" @click="addcancel">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog :modal="false" title="编辑用户" :visible.sync="systemUserUPUser" width="30%" :closeOnClickModal="false">
					<div class="systemUserPC-add-user">
						<div class="systemUserPC-add-user-table">
							<div class="systemUserPC-add-user-li">
								<div>角色</div>
								<div>
									<el-select v-model="upuserObj.PERTB003ID" placeholder="请选择" >
									    <el-option
									      v-for="item in roeList"
									      :key="item.value"
									      :label="item.label"
									      :value="item.value">
									    </el-option>
									  </el-select>
								</div>
								<div>*必填*</div>
							</div>
							<div class="systemUserPC-add-user-li">
								<div>手机号</div>
								<div>
									<input type="text" value="" maxlength="11" v-model="upuserObj.PERTB005CA03" @blur="upphoneBlur"/>
								</div>
								<div>*必填*</div>
							</div>
							<div class="systemUserPC-add-user-li">
								<div>密码</div>
								<div>
									<input type="password" value="" maxlength="16" v-model="upuserObj.PERTB005CA01"/>
								</div>
								<div></div>
							</div>
							<div class="systemUserPC-add-user-li">
								<div>姓名</div>
								<div>
									<input type="text" value="" maxlength="16" v-model="upuserObj.PERTB005CA02"/>
								</div>
								<div>*必填*</div>
							</div>
						</div>
						<div class="systemUserPC-add-user-btn">
							<el-button type="primary" @click="saveUpUser">保存</el-button>
							<el-button type="warning" @click="upcancel">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default{
		props:{
			cusCode:String
		},
		data(){
			return {
				options: [
					{
						value: '',
						label: '全部'
					},
					{
						value: '0',
						label: '普通用户'
					},
					{
						value: '1',
						label: '管理员用户'
					},
				],
				value:'',
				usertext:'',
				typeid:'',
				systemUserAddUser:false,
				systemUserUPUser:false,
				currentPage:1,
				pageSize:1,//页数
				pageNum:10,//条数，
				count:1,//总条数,
				userList:[],
				userType:this.$store.state.uobj.pertb005.pertb005cb00,
				roeList:[],
				rolevalue:'',
				adduserObj:{
					PERTB005CA00:'',
					PERTB005CA01:'',
					PERTB005CA02:'',
					PERTB005CA03:'',
					PERTB005CD01:'',
					PERTB003ID:'',
					PERTB005CB00:''
				},
				upuserObj:{
					PERTB005CA00:'',
					PERTB005ID:'',
					PERTB005CA01:'',
					PERTB005CA02:'',
					PERTB005CA03:'',
					PERTB005CD00:'',
					PERTB005CD01:'',
					PERTB003ID:''
				},
				uproleval:'',
				isPhone:false,
				isUname:false,
				isUpPhone:true,
				isUPUname:true,
				isOption:[
					{
						value: '1',
						label: '启用'
					},
					{
						value: '0',
						label: '禁用'
					},
				],
				isOptionval:'',
				oldphone:'',
				oldUserName:'',
				userobj:'',
				solelist:'',
				currentUrl:this.$route.path,
				historyInfo:''
			}
		},
		mounted() {
			var str=this.cusCode
			console.log(str)
			this.userobj=this.$store.state.uobj
			this.userPostList()
			this.postRole()
			this.adduserObj.PERTB005CB00='CUS-1'
			this.adduserObj.PERTB005CD01=this.cusCode
		},
		methods:{
			disableClick(item) {// 禁用
				this.$confirm(`此操作将禁用：${item.PERTB005CA02}, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url="/per/pertb005/updateStatus"
					var data={
						PERTB005ID:item.PERTB005ID,
						PERTB005CD00:0,
					}
					this.axios.post(url,data).then(res=>{
						// console.log(res)
						if(res.data.code==200){
							this.$message({
								type: 'success',
								message: '已禁用!'
							});
							this.userPostList()
						}
					})
				}).catch(() => {
				});
			},
			revClick(item){//启用
				this.$confirm(`此操作将启用:${item.PERTB005CA02}, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url="/per/pertb005/updateStatus"
					var data={
						PERTB005ID:item.PERTB005ID,
						PERTB005CD00:1,
					}
					this.axios.post(url,data).then(res=>{
						// console.log(res)
						if(res.data.code==200){
							this.$message({
								type: 'success',
								message: '已启用!'
							});
							this.userPostList()
						}
					})
				}).catch(() => {
				});
			},
			deleteClick(item) {// 删除
				this.$confirm(`此操作将删除:${item.PERTB005CA02}, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url="/per/pertb005/delete"
					var data={
						PERTB005ID:item.PERTB005ID
					}
					this.axios.post(url,data).then(res=>{
						// console.log(res)
						if(res.data.code==200){
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.userPostList()
						}
					})
				}).catch(() => {
				});
			},
			handleSizeChange(val) {//每页多少条
				this.pageNum=val
				this.pageSize=1
				this.userPostList()
			},
			handleCurrentChange(val) {//当前页
				this.pageSize=val
				this.userPostList()
			},
			userPostList(){//查询列表
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var PERTB005CD01=this.cusCode
				var url="/per/pertb005/selectPageList"
				var data={
					PERTB005CD01:PERTB005CD01,
					PERTB003CB01:this.typeid,
					PERTB005CA00:this.usertext,
					page:this.pageSize,
					limit:this.pageNum,
					PERTB005CB00:'CUS-1'
				}
				this.axios.post(url,data).then(res=>{
					// console.log(res)
					if(res.data.code==200){
						this.count=res.data.count
						this.userList=res.data.data||[]
					}else{
						this.count=0
						this.userList=[]
						this.$message.error(res.data.message)
					}
					setTimeout(()=>{
						loading.close()
					},500)
				}).catch(()=>{
					loading.close()
				})
			},
			queryClick(){//条件查询
				this.pageSize=1
				this.userPostList()
			},
			postRole(){//查询角色
				var PERTB005CD01=this.cusCode
				var url="/per/pertb005/selectPertb003"
				var data={
					PERTB003CD01:PERTB005CD01,
					PERTB003CB00:'CUS-1'
				}
				this.axios.post(url,data).then((res)=>{
					// console.log(res)
					if(res.data.code==200){
						var data=res.data.data
						var arr=[]
						for(var i=0;i<data.length;i++){
							arr.push({
								value: data[i].PERTB003ID,
								label: data[i].PERTB003CA00
							})
						}
						this.roeList=arr
					}
				})
			},
			valchange(val){
				this.typeid=val
			},
			rolechange(val){//添加角色下拉监听
				this.adduserObj.PERTB003ID=val
			},
			addclick(){//点击添加
			console.log(this.cusCode)
				this.systemUserAddUser=true
				this.initAddObj()
			},
			saveUserPost(){//添加保存
				if(this.adduserObj.PERTB003ID.trim().length==0) return this.$message.error('请选择角色')
				if(this.adduserObj.PERTB005CA02.trim().length==0) return this.$message.error('请输入姓名')
				if(!this.isPhone) return this.$message.error('请输入有效手机号!')
				if(this.adduserObj.PERTB005CA01.length>0){
					if(!(/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,16}$/.test(this.adduserObj.PERTB005CA01))) return this.$message.error('请输入密码为6-16位数字字母组合!')
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url="/per/pertb005/insert"
				var data=this.adduserObj
				this.axios.post(url,data).then((res)=>{
					// console.log(res)
					if(res.data.code==200){
						this.systemUserAddUser=!this.systemUserAddUser
						this.initAddObj()
						this.pageSize=1
						this.userPostList()
					}else{
						this.$message.error(res.data.message)
					}
					setTimeout(()=>{
						loading.close()
					},500)
				}).catch(()=>{
					loading.close()
				})
			},
			addcancel(){//添加取消
				this.systemUserAddUser=!this.systemUserAddUser
				this.initAddObj()
			},
			phoneBlur(){//校验手机号
				if(!(/^[1][3-9][0-9]{9}$/.test(this.adduserObj.PERTB005CA03))) return 
				var url="/per/pertb005/checkPhone"
				var data={
					PERTB005CA03:this.adduserObj.PERTB005CA03,
					PERTB005CD01:this.cusCode
				}
				this.axios.post(url,data).then((res)=>{
						if(res.data.code==500){
							this.isPhone=false
							this.$message({
								type: 'error',
								message: '手机号已存在!'
							});
						}else if(res.data.code==200){
							this.isPhone=true
						}
				})
			},
			unameBlur(){//校验用户名
				if(this.adduserObj.PERTB005CA00.trim().length==0) return 
				var url="/per/pertb005/checkUserName"
				var data={
					PERTB005CA00:this.adduserObj.PERTB005CA00
				}
				this.axios.post(url,data).then((res)=>{
					// console.log(res)
					// if(res.data.code==200){
						if(res.data.code==500){
							this.isUPUname=false
							this.$message({
								type: 'error',
								message: '用户名已存在!'
							});
						}else if(res.data.code==200){
							this.isUname=true
						}
					// }
				})
			},
			updateClick(item){//修改用户信息
				this.systemUserUPUser=true
				this.upuserObj.PERTB003ID=item.PERTB003ID//角色id
				this.upuserObj.PERTB005ID=item.PERTB005ID//用户d
				this.upuserObj.PERTB005CA03=item.PERTB005CA03//手机号
				this.upuserObj.PERTB005CA02=item.PERTB005CA02//姓名
				this.upuserObj.PERTB005CD00=item.PERTB005CD00=='启用'?'1':'0'//启用id
				this.oldphone=item.PERTB005CA03
				this.oldUserName=item.PERTB005CA00
			},
			upunameBlur(){//校验用户名
				if(this.oldUserName==this.upuserObj.PERTB005CA00) return
				if(this.upuserObj.PERTB005CA00.trim().length==0) return
				var url="/per/pertb005/checkUserName"
				var data={
					PERTB005CA00:this.upuserObj.PERTB005CA00
				}
				this.axios.post(url,data).then((res)=>{
						if(res.data.code==500){
							this.$message({
								type: 'error',
								message: '用户名已存在!'
							});
							this.isUPUname=false
						}else if(res.data.code==200){
							this.isUPUname=true
						}
				})
			},
			upphoneBlur(){//修改用户信息校验手机号
				if((/^[1][3-9][0-9]{9}$/.test(this.upuserObj.PERTB005CA03))&&this.oldphone==this.upuserObj.PERTB005CA03) return 
				
				var url="/per/pertb005/checkPhone"
				var data={
					PERTB005CA03:this.upuserObj.PERTB005CA03,
					PERTB005CD01:this.cusCode
				}
				this.axios.post(url,data).then((res)=>{
						if(res.data.code==500){
							this.$message({
								type: 'error',
								message: '手机号已存在!'
							});
							this.isUpPhone=false
						}else if(res.data.code==200){
							this.isUpPhone=true
						}
				})
			},
			saveUpUser(){//修改用户信息保存
				if(this.upuserObj.PERTB003ID.trim().length==0) return this.$message.error('请选择角色')
				if(!this.isUpPhone) return this.$message.error('请输入有效手机号!')
				if(this.upuserObj.PERTB005CA02.trim().length==0) return this.$message.error('请输入姓名')
				if(this.upuserObj.PERTB005CA01.length>0){
					if(!(/^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{6,16}$/.test(this.upuserObj.PERTB005CA01))) return this.$message.error('请输入密码为6-16位数字字母组合!')
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url="/per/pertb005/update"
				var data=this.upuserObj
				this.axios.post(url,data).then((res)=>{
					// console.log(res)
					if(res.data.code==200){
						this.systemUserUPUser=false
						this.userPostList()
						this.initUpobj()
						this.$message.success('修改成功')
					}else{
						this.$message.error(res.data.message)
					}
					setTimeout(()=>{
						loading.close()
					},500)
				}).catch(()=>{
					loading.close()
				})
			},
			upcancel(){//修改取消
				this.systemUserUPUser=false
				this.initUpobj()
			},
			initAddObj(){//初始化添加用户对象
				this.adduserObj={
					PERTB005CA00:'',
					PERTB005CA01:'',
					PERTB005CA02:'',
					PERTB005CA03:'',
					PERTB005CD01:'',
					PERTB003ID:'',
					PERTB005CB00:''
				}
				this.isPhone=false
				this.isUname=false
				this.adduserObj.PERTB005CB00='CUS-1'
				this.adduserObj.PERTB005CD01=this.cusCode
			},
			initUpobj(){//初始化修改用户对象
				this.upuserObj={
					PERTB005ID:'',
					PERTB005CA01:'',
					PERTB005CA02:'',
					PERTB005CA03:'',
					PERTB005CD00:'',
					PERTB005CD01:'',
					PERTB003ID:''
				}
				this.isUpPhone=true
				this.oldphone=''
				this.oldUserName=''
			}
			
		}
	}
</script>
<style scoped>
	.systemUserPC{
		padding: 30px 40px 40px 20px;
	}
	.systemUserPC-no-text{
		font-size: 18px;
		text-align: center;
		line-height: 80px;
		border-bottom:1px solid #CDCDCD;
	}
	.systemUserPC-conditions{
		display: flex;
		font-size: 18px;
	}
	.systemUserPC-conditions-type{
		padding-right: 30px;
	}
	.systemUserPC-conditions-name{
	}
	.systemUserPC-conditions-name input{
		display: inline-block;
		width: 240px;
		height: 40px;
		line-height: 40px;
		padding: 0 0 0 5px;
		border-radius: 5px;
		border: 1px solid #CDCDCD;
		box-sizing: border-box;
	}
	.systemUserPC-conditions-name input:focus{
		outline: none;
	}
	.systemUserPC-btn{
		padding-top: 20px;
	}
	.systemUserPC-prompt-text{
		padding-top: 15px;
		font-size: 16px;
		color: #333;
	}
	.systemUserPC-table{
		margin-top: 20px;
	}
	.systemUserPC-table-li{
		display: flex;
		text-align: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #333;
		border-bottom:1px solid #CDCDCD;
	}
	.systemUserPC-table-li:first-child{
		font-weight: bold;
		font-size: 16px;
		height: 48px;
		line-height: 48px;
	}
	
	.systemUserPC-table-li>div{
		white-space:nowrap;
		overflow:hidden;
		text-overflow:ellipsis;
	}
	.systemUserPC-table-li-username{
		flex:.6;
	}
	.systemUserPC-table-li-role{
		flex:.6;
	}
	.systemUserPC-table-li-type{
		flex:.6;
	}
	.systemUserPC-table-li-name{
		flex:.5;
	}
	.systemUserPC-table-li-phone{
		flex:.6;
	}
	.systemUserPC-table-li-phonelogin{
		flex:.6;
	}
	.systemUserPC-table-li-actuvstate{
		flex:.5;
	}
	.systemUserPC-table-li-state{
		flex:.3;
	}
	.systemUserPC-table-li-oper{
		flex:1;
	}
	.systemUserPC-pagesize{
		margin-top: 20px;
		text-align: right;
	}
	.systemUserPC-add-user{
		padding-left: 20px;
	}
	.systemUserPC-add-user-li{
		display: flex;
		height: 42px;
		line-height: 42px;
		text-align: center;
		font-size: 16px;
		color: #333;
	}
	.systemUserPC-add-user-li>div{
		flex:1;
		border:1px solid #CDCDCD;
		border-top:none ;
	}
	.systemUserPC-add-user-li:first-child>div{
		border-top:1px solid #CDCDCD;
	}
	.systemUserPC-add-user-li>div:last-child{
		flex:.3;
		border:none;
		color: #FF4D35;
	}
	.systemUserPC-add-user-li>div:first-child{
		border-right:none;
		background: rgba(240,252,255,1);
	}
	.systemUserPC-add-user-li input{
		border: none;
		height: 100%;
		width: 100%;
		box-sizing: border-box;
		vertical-align: top;
		text-align: center;
		font-size: 16px;
	}
	.systemUserPC-add-user-btn{
		text-align: center;
		padding: 40px 0 20px 0;
	}
</style>
